import { render, staticRenderFns } from "./FileInputImageCustom.vue?vue&type=template&id=132af626&scoped=true&"
import script from "./FileInputImageCustom.vue?vue&type=script&lang=js&"
export * from "./FileInputImageCustom.vue?vue&type=script&lang=js&"
import style0 from "./FileInputImageCustom.vue?vue&type=style&index=0&id=132af626&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "132af626",
  null
  
)

export default component.exports